import upReader from '@vp/up-reader';
import { EXPIRES_3DAYS } from './src-constants-api.constants.js';
import { useCouponDetailsStore } from './src-store-couponDetails.store.js';

const useGetCouponCode = () => {
  const pricingContext = useCouponDetailsStore((state) => state.pricingContext);
  const pricingContextCouponCode = pricingContext?.value?.couponCode;
  if (pricingContextCouponCode) {
    return pricingContextCouponCode;
  }
  const couponCodeFromURL = getCouponCodeFromUrl();
  if (couponCodeFromURL) {
    setCachedCouponInfo(couponCodeFromURL);
    return couponCodeFromURL;
  }
  const userContextCouponCode = validateAndFetchUserContextCoupon();
  if (userContextCouponCode) {
    setCachedCouponInfo(userContextCouponCode);
    return userContextCouponCode;
  }
  return "";
};
const getCouponCodeFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("couponCode") || params.get("couponcode");
};
const getCouponCodeFromUpReader = () => {
  return upReader.getTrait("couponCode") || upReader.getTrait("couponcode");
};
const isCouponWithinTimeLimit = (couponCodeTimestamp) => {
  return Date.now() - couponCodeTimestamp < EXPIRES_3DAYS;
};
const getCachedCouponInfo = () => {
  try {
    return JSON.parse(localStorage.getItem("landingCouponInfo") || "{}");
  } catch (e) {
    console.error("Error parsing couponInfo from localStorage", e);
    return {};
  }
};
const setCachedCouponInfo = (couponCode) => {
  return localStorage.setItem(
    "landingCouponInfo",
    JSON.stringify({
      couponCode,
      couponCodeTime: Date.now().toString()
    })
  );
};
const validateAndFetchUserContextCoupon = () => {
  const userContextCouponCode = getCouponCodeFromUpReader();
  const couponCodeTime = upReader.getTrait("couponCodeTime");
  const userContextCouponTimestamp = couponCodeTime ? new Date(upReader.getTrait("couponCodeTime")).getTime() : void 0;
  const { couponCode: cachedCouponCode, couponCodeTime: cachedCouponTimestamp } = getCachedCouponInfo();
  if (userContextCouponCode && userContextCouponTimestamp) {
    const isFreshCoupon = !cachedCouponCode || userContextCouponCode !== cachedCouponCode;
    if (isFreshCoupon && isCouponWithinTimeLimit(userContextCouponTimestamp)) {
      return userContextCouponCode;
    }
    if (userContextCouponCode === cachedCouponCode && (isCouponWithinTimeLimit(userContextCouponTimestamp) || isCouponWithinTimeLimit(Number(cachedCouponTimestamp)))) {
      return userContextCouponCode;
    }
  }
  return void 0;
};

export { useGetCouponCode };
//# sourceMappingURL=src-hooks-useGetCouponCode.js.map
